import React from 'react';
import logo from './logo.png';

function LogoArea (props) {
  const {theme} = props;
  return (
    <div className="loginLogo" style={theme.logoArea}>
      <img src={logo} alt="lapsys logo" />
    </div>
  );
}

export default LogoArea;
